<template lang="pug">

  v-dialog(v-model="dialog" width="100%" max-width="600px" :persistent="loadingWindow || saving")

    .dialogHeader

      .dialogHeaderTitle
        | Dados do usuário

      .dialogHeaderClose
        .dialogCloseButton.mdi.mdi-close(@click="closeUser()")

    .dialogBody

      .loadingModal(v-if="loadingWindow || saving")
        .loadingModalResult
          .buttonLoader
            span
          .dialogLoadingText.mt-2 {{ loadingWindow ? 'Abrindo...' : 'Salvando...' }}

      .dialogBodyContent

        //-
          -
          -

        .userEditTitle.mb-3
          | Dados gerais do usuário:

        .dutyDetails

          .dutyDetail
            span.dutyDetailName Nome:
            span.dutyDetailValue
              img(:src="perfil.img").editUserUserImage
              input(v-model="local.nome" maxlength="64" placeholder="Informe até 64 caracteres" :disabled="loadingWindow || saving").userField.userField--userName

          .dutyDetail
            span.dutyDetailName Telefone:
            span.dutyDetailValue
              input(v-model="local.telefone" maxlength="15" placeholder="Formato (99) 99999-9999 ou (99) 9999-9999" :disabled="loadingWindow || saving" @input="onPhoneChange" @paste="onPhoneChange").userField

          .dutyDetail
            span.dutyDetailName CPF:
            span.dutyDetailValue
              input(v-model="local.cpf" maxlength="14" placeholder="Formato 999.999.999-99" :disabled="loadingWindow || saving" @input="onCpfChange" @paste="onCpfChange").userField

          .dutyDetail
            span.dutyDetailName CNPJ:
            span.dutyDetailValue
              input(v-model="local.cnpj" maxlength="18" placeholder="Formato 99.999.999/9999-99" :disabled="loadingWindow || saving" @input="onCnpjChange" @paste="onCnpjChange").userField

          .dutyDetail
            span.dutyDetailName CRM:
            span.dutyDetailValue
              input(v-model="local.crm" maxlength="13" placeholder="Informe até 13 caracteres" :disabled="loadingWindow || saving").userField

          .dutyDetail
            span.dutyDetailName.dutyDetailName--textarea Dados bancários:
            span.dutyDetailValue.dutyDetailValue--textarea.dutyDetailValue--conta
              textarea(v-model="local.conta" maxlength="160" placeholder="Informe até 160 caracteres" :disabled="loadingWindow || saving").userFieldBankAccount

        //-
          -
          -

        template(v-if="!!groupID === true")

          .userEditTitle.mt-7.mb-3
            | Dados vinculados ao grupo:

          .dutyDetails

            .dutyDetail
              span.dutyDetailName Apelido:
              span.dutyDetailValue
                input(v-model="local.groupNickname" maxlength="16" placeholder="Informe até 16 caracteres" :disabled="loadingWindow || saving").userField

            .dutyDetail
              span.dutyDetailName Valor hora:
              span.dutyDetailValue
                app-money-light(:value="local.groupHourlyRate" @input="onBlurUserGroupHourlyRateValue" :blur-event="onBlurUserGroupHourlyRateValue" :disabled="loadingWindow || saving").userField

          .userEditTitle.mt-7.mb-3
            | Dados vinculados a escala:

          .dutyDetails

            .dutyDetail
              span.dutyDetailName Escala:
              span.dutyDetailValue
                .sosField
                  sos-select(label="" :default="selectedScaleID" :items="scalesOptions" @sosSelectChanged="onSelectScale" :disabled="loadingWindow || saving" :fullscreen="true" fullscreenTitle="Escalas")

            //- Nada específica
            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName Valor hora:
              span.dutyDetailValue
                app-money-light(:value="local.selectedScaleHourlyRate" @input="onInputUserScaleHourlyRateValue" :blur-event="onBlurUserScaleHourlyRateValue" :disabled="loadingWindow || saving || selectedScaleID === ''").userField

            //- Menos específica
            //- .dutyDetail(v-if="selectedScaleID !== ''")
            //-   span.dutyDetailName Valor Geral:
            //-   span.dutyDetailValue
            //-     app-money-light(
            //-       :value="local.selectedGeneralHourlyRate"
            //-       @input="onInputUserScaleGeneralHourlyRate"
            //-       :blur-event="() => {}"
            //-       :disabled="loadingWindow || saving || selectedScaleID === ''"
            //-     ).userField

            //- Médio específica
            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName Seg a Sex:
              span.dutyDetailValue
                app-money-light(
                  :value="local.selectedWeekdaysHourlyRate"
                  @input="onInputUserScaleWeekdaysHourlyRate"
                  :blur-event="() => {}"
                  :disabled="loadingWindow || saving || selectedScaleID === '' || this.local.selectedDayShiftHourlyRate > 0.00 || this.local.selectedNightShiftHourlyRate > 0.00"
                ).userField

            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName FDS:
              span.dutyDetailValue
                app-money-light(
                  :value="local.selectedWeekendHourlyRate"
                  @input="onInputUserScaleWeekendHourlyRate"
                  :blur-event="() => {}"
                  :disabled="loadingWindow || saving || selectedScaleID === '' || this.local.selectedDayShiftHourlyRate > 0.00 || this.local.selectedNightShiftHourlyRate > 0.00"
                ).userField

            //- SE É PREENCHIDO DIURNO E NOTURNO, NÃO PODE SER PREENCHIDO OS CAMPOS ACIMA DE Seg a Sex e FDS
            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName Diurno:
              span.dutyDetailValue
                app-money-light(
                  :value="local.selectedDayShiftHourlyRate"
                  @input="onInputUserScaleDayShiftHourlyRate"
                  :blur-event="() => {}"
                  :disabled="loadingWindow || saving || selectedScaleID === '' || this.local.selectedWeekdaysHourlyRate > 0.00 || this.local.selectedWeekendHourlyRate > 0.00"
                ).userField

            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName Noturno:
              span.dutyDetailValue
                app-money-light(
                  :value="local.selectedNightShiftHourlyRate"
                  @input="onInputUserScaleNightShiftHourlyRate"
                  :blur-event="() => {}"
                  :disabled="loadingWindow || saving || selectedScaleID === '' || this.local.selectedWeekdaysHourlyRate > 0.00 || this.local.selectedWeekendHourlyRate > 0.00"
                ).userField

            //- Mais específica
            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName Seg a Sex - Diurno:
              span.dutyDetailValue
                app-money-light(
                  :value="local.selectedWeekdaysDayShiftHourlyRate"
                  @input="onInputUserScaleWeekdaysDayShiftHourlyRate"
                  :blur-event="() => {}"
                  :disabled="loadingWindow || saving || selectedScaleID === ''"
                ).userField

            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName Seg a Sex - Noturno:
              span.dutyDetailValue
                app-money-light(
                  :value="local.selectedWeekdaysNightShiftHourlyRate"
                  @input="onInputUserScaleWeekdaysNightShiftHourlyRate"
                  :blur-event="() => {}"
                  :disabled="loadingWindow || saving || selectedScaleID === ''"
                ).userField

            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName FDS - Diurno:
              span.dutyDetailValue
                app-money-light(
                  :value="local.selectedWeekendDayShiftHourlyRate"
                  @input="onInputUserScaleWeekendDayShiftHourlyRate"
                  :blur-event="() => {}"
                  :disabled="loadingWindow || saving || selectedScaleID === ''"
                ).userField

            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName FDS - Noturno:
              span.dutyDetailValue
                app-money-light(
                  :value="local.selectedWeekendNightShiftHourlyRate"
                  @input="onInputUserScaleWeekendNightShiftHourlyRate"
                  :blur-event="() => {}"
                  :disabled="loadingWindow || saving || selectedScaleID === ''"
                ).userField

            //- Valor Mensal
            .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName Valor mensal:
              span.dutyDetailValue
                app-money-light(:value="local.selectedScaleMonthlyRate" @input="onInputUserScaleMonthlyRateValue" :blur-event="onBlurUserScaleMonthlyRateValue" :disabled="loadingWindow || saving || selectedScaleID === ''").userField
                .scaleMonthlyRateTextDisabled(v-if="local.selectedScaleMonthlyRate <= 0") Não definido (Não aparecerá na folha de pagamento)

            //- [staging-portaltelemedicina / master-portaltelemedicina]
            //- .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName.dutyDetailName--heightFix Tempo de consulta do usuário na escala:
              span.dutyDetailValue
                .sosField
                  sos-select(label="" :default="local.scaleConsultationDuration" :items="consultationTimeOptions" @sosSelectChanged="onSelectConsultationTime" :disabled="loadingWindow || saving || selectedScaleID === ''" :fullscreen="true" fullscreenTitle="Tempo de consulta")

            //- .dutyDetail(v-if="selectedScaleID !== ''")
              span.dutyDetailName.dutyDetailName--heightFix.dutyDetailName--disabled Tempo de consulta da escala:
              span.dutyDetailValue.dutyDetailValue--disabled
                | {{ Number(scaleConsultationDuration) === 0 ? 'Desativado' : `${scaleConsultationDuration} minutos` }}
            //- [staging-portaltelemedicina / master-portaltelemedicina]

          template(v-if="showUserCapabilities")
            .userEditTitle.mt-7.mb-3
              | Permissões no grupo
              div(v-for="group in Object.keys(userCapabilitiesPerGroup)" :key="group")
                span.dutyDetailName.unsetWidth.mt-5.mb-2 {{ group }}
                div(v-for="capability in userCapabilitiesPerGroup[group]" :key="capability.value")
                  .foundUserWrapper
                    sos-checkbox(:id="capability.value" :label="capability.label" :checked="userCapabilitiesInGroup[capability.value]" @click="() => onSelectedUserCapabilityInGroup(capability.value)" :disabled="loadingWindow || saving")

        //-
          -
          -

        .dutyDetailButton

          sos-button(
            @buttonClick="saveUser"
            size="medium"
            buttonIcon="mdi-refresh"
            buttonIconSize="16"
            color="success"
            :loading="saving"
            :disabled="hasChanges === false || loadingWindow || saving"
            buttonLabel="Salvar"
          )

</template>

<script>

  // Vuex
  import { mapState } from 'vuex'

  import { processUserGroupCapabilities, processSelectedCapabilities } from '@/functions'
  import { USER_CAPABILITIES } from '@/constants'

  import { getUserByUserID, fbFullUpdate } from '@/services/firebase'

  import { processUserProfile } from '@/mixins/utils.js'
  import cpfMixin from '@/mixins/cpf.mixin'
  import cnpjMixin from '@/mixins/cnpj.mixin'

  import userProfileBroken from '@/assets/images/user-profile-broken.png'

  import SosButton from '@/components/SosButton'
  import SosSelect from '@/components/SosSelect'
  import SosCheckbox from '@/components/SosCheckbox'
  import AppMoneyLight from '@/components/base/AppMoneyLight'

  //
  //
  //

  const checkPhone = telefone => /^\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$/.test(telefone)

  const checkUsername = username => username.trim().length >= 3 // /\S+(?:\s+\S+)+/.test(username)

  const applyPhoneMask = phone => {
    let vPhone = String(phone).trim()
    vPhone = vPhone.replace(/[^0-9]/g, '')
    const lPhone = vPhone.length
    vPhone = vPhone.replace(/^(\d\d)(\d)/g, '($1) $2')
    if (lPhone > 10) {
      vPhone = vPhone.replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15)
    } else {
      vPhone = vPhone.replace(/(\d{4})(\d)/, '$1-$2').slice(0, 14)
    }

    return vPhone
  }

  const applyCpfMask = cpf => {
    let vCpf = String(cpf).trim()

    vCpf = vCpf.replace(/[^0-9]/g, '')
    vCpf = vCpf.length > 11 ? vCpf.slice(0, 11) : vCpf // correção para CPF maior que 11 (bug ao colar número grande)

    return vCpf.length === 11 ? vCpf/* cpf */.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4') : vCpf
  }

  const applyCnpjMask = cnpj => {
    let vCnpj = String(cnpj).trim()

    vCnpj = vCnpj.replace(/[^0-9]/g, '')
    vCnpj = vCnpj.length > 14 ? vCnpj.slice(0, 14) : vCnpj // correção para CNPJ maior que 14 (bug ao colar número grande)

    return vCnpj.length === 14 ? vCnpj/* cnpj */.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : vCnpj
  }

  //
  //
  //

  const userCapabilitiesPerGroup = () => {
    const key = 'group'

    const items = USER_CAPABILITIES.reduce((result, item) => {
      const keyValue = typeof key === 'function' ? key(item) : item[key]
      if (!result[keyValue]) result[keyValue] = []
      result[keyValue].push(item)
      return result
    }, {})

    return items
  }

  //
  //
  //

  export default {
    name: 'ManagerUserModal',

    components: {
      'sos-button': SosButton,
      'sos-select': SosSelect,
      'sos-checkbox': SosCheckbox,
      'app-money-light': AppMoneyLight,
    },

    mixins: [
      cpfMixin,
      cnpjMixin,
    ],

    data () {
      return {
        userProfileBroken,

        dialog: false,
        loadingWindow: true,
        saving: false,

        selectedScaleID: '',
        groupID: '',
        userID: '',

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        scaleConsultationDuration: '0',
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        local: {
          nome: '',
          telefone: '',
          cpf: '',
          cnpj: '',
          crm: '',
          conta: '',
          contaFormatada: '',
          groupHourlyRate: '0',
          groupNickname: '',
          selectedScaleHourlyRate: '0',
          // selectedGeneralHourlyRate: '0',
          selectedWeekdaysHourlyRate: '0',
          selectedWeekendHourlyRate: '0',
          selectedDayShiftHourlyRate: '0',
          selectedNightShiftHourlyRate: '0',
          selectedWeekdaysDayShiftHourlyRate: '0',
          selectedWeekdaysNightShiftHourlyRate: '0',
          selectedWeekendDayShiftHourlyRate: '0',
          selectedWeekendNightShiftHourlyRate: '0',
          // Valor mensal
          selectedScaleMonthlyRate: '0',
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          // Duração da consulta agendada
          scaleConsultationDuration: '0',
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        },
        perfil: {
          img: userProfileBroken,
          nome: 'Carregando...',
          telefone: 'Carregando...',
          cpf: 'Carregando...',
          cnpj: 'Carregando...',
          crm: 'Carregando...',
          conta: 'Carregando...',
          groupHourlyRate: 'Carregando...',
          groupNickname: 'Carregando...',
          selectedScaleHourlyRate: 'Carregando...',
          // selectedGeneralHourlyRate: 'Carregando...',
          selectedWeekdaysHourlyRate: 'Carregando...',
          selectedWeekendHourlyRate: 'Carregando...',
          selectedDayShiftHourlyRate: 'Carregando...',
          selectedNightShiftHourlyRate: 'Carregando...',
          selectedWeekdaysDayShiftHourlyRate: 'Carregando...',
          selectedWeekdaysNightShiftHourlyRate: 'Carregando...',
          selectedWeekendDayShiftHourlyRate: 'Carregando...',
          selectedWeekendNightShiftHourlyRate: 'Carregando...',
          // Valor mensal
          selectedScaleMonthlyRate: 'Carregando...',
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          // Duração da consulta agendada
          scaleConsultationDuration: 'Carregando...',
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        },

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        consultationTimeOptions: [
          { key: '0', value: '0', text: 'Desativado' },
          { key: '06', value: '6', text: '6 minutos' },
          { key: '10', value: '10', text: '10 minutos' },
          { key: '15', value: '15', text: '15 minutos' },
          { key: '20', value: '20', text: '20 minutos' },
          { key: '30', value: '30', text: '30 minutos' },
          { key: '60', value: '60', text: '60 minutos' },
        ],
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        // Editar capacidades do usuário (Funcionalidade de usuário master)
        showUserCapabilities: false,
        userCapabilitiesPerGroup: userCapabilitiesPerGroup(),
        userCapabilitiesInGroup: {},
        capabilitiesChanged: false,
      }
    },

    //
    //
    //

    computed: {
      ...mapState({
        listeners: state => state.app.listeners,
      }),

      hasChanges ()
      {
        //
        // DADOS DO BANCO, MAS QUE O GESTOR PODE ALTERAR POR MEIO DA JANELA ATUAL
        //

        const localName = String(this.local.nome || '').trim()
        const localPhone = String(this.local.telefone || '').trim()
        let localCpf = String(this.local.cpf || '').replace(/[^0-9]/g, '')
        localCpf = localCpf.length > 11 ? localCpf.slice(0, 11) : localCpf
        let localCnpj = String(this.local.cnpj || '').replace(/[^0-9]/g, '')
        localCnpj = localCnpj.length > 14 ? localCnpj.slice(0, 14) : localCnpj
        const localCrm = String(this.local.crm || '').trim()
        const localBankAccount = String(this.local.conta || '').trim()
        const localCurrentUserGroupHourlyRate = this.local.groupHourlyRate
        const localCurrentUserGroupNickname = String(this.local.groupNickname || '').trim()
        const localSelectedScaleCurrentUserHourlyRate = this.local.selectedScaleHourlyRate
        // const localSelectedScaleCurrentUserGeneralHourlyRate = this.local.selectedGeneralHourlyRate
        const localSelectedScaleCurrentUserWeekdaysHourlyRate = this.local.selectedWeekdaysHourlyRate
        const localSelectedScaleCurrentUserWeekendHourlyRate = this.local.selectedWeekendHourlyRate
        const localSelectedScaleCurrentUserDayShiftHourlyRate = this.local.selectedDayShiftHourlyRate
        const localSelectedScaleCurrentUserNightShiftHourlyRate = this.local.selectedNightShiftHourlyRate
        const localSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate = this.local.selectedWeekdaysDayShiftHourlyRate
        const localSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate = this.local.selectedWeekdaysNightShiftHourlyRate
        const localSelectedScaleCurrentUserWeekendDayShiftHourlyRate = this.local.selectedWeekendDayShiftHourlyRate
        const localSelectedScaleCurrentUserWeekendNightShiftHourlyRate = this.local.selectedWeekendNightShiftHourlyRate
        const localSelectedScaleCurrentUserMonthlyRate = this.local.selectedScaleMonthlyRate
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        const localSelectedScaleCurrentUserConsultationTime = this.local.scaleConsultationDuration
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        //
        // DADOS NO BANCO
        //

        const dbUserName = String(this.perfil.nome || '').trim()
        const dbUserPhone = String(this.perfil.telefone || '').trim()
        let dbUserCpf = String(this.perfil.cpf || '').replace(/[^0-9]/g, '')
        dbUserCpf = dbUserCpf.length > 11 ? dbUserCpf.slice(0, 11) : dbUserCpf
        let dbUserCnpj = String(this.perfil.cnpj || '').replace(/[^0-9]/g, '')
        dbUserCnpj = dbUserCnpj.length > 14 ? dbUserCnpj.slice(0, 14) : dbUserCnpj
        const dbUserCrm = String(this.perfil.crm || '').trim()
        const dbUserBankAccount = String(this.perfil.conta || '').trim()
        const dbCurrentUserGroupHourlyRate = this.perfil.groupHourlyRate
        const dbCurrentUserGroupNickname = String(this.perfil.groupNickname || '').trim()
        const dbSelectedScaleCurrentUserHourlyRate = this.perfil.selectedScaleHourlyRate // || '0'
        // const dbSelectedScaleCurrentUserGeneralHourlyRate = this.perfil.selectedGeneralHourlyRate
        const dbSelectedScaleCurrentUserWeekdaysHourlyRate = this.perfil.selectedWeekdaysHourlyRate
        const dbSelectedScaleCurrentUserWeekendHourlyRate = this.perfil.selectedWeekendHourlyRate
        const dbSelectedScaleCurrentUserDayShiftHourlyRate = this.perfil.selectedDayShiftHourlyRate
        const dbSelectedScaleCurrentUserNightShiftHourlyRate = this.perfil.selectedNightShiftHourlyRate
        const dbSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate = this.perfil.selectedWeekdaysDayShiftHourlyRate
        const dbSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate = this.perfil.selectedWeekdaysNightShiftHourlyRate
        const dbSelectedScaleCurrentUserWeekendDayShiftHourlyRate = this.perfil.selectedWeekendDayShiftHourlyRate
        const dbSelectedScaleCurrentUserWeekendNightShiftHourlyRate = this.perfil.selectedWeekendNightShiftHourlyRate
        const dbSelectedScaleCurrentUserMonthlyRate = this.perfil.selectedScaleMonthlyRate // || '0'
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        const dbSelectedScaleCurrentUserConsultationTime = this.perfil.scaleConsultationDuration // || '0'
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        return (
          dbUserName !== localName ||
          dbUserPhone !== localPhone ||
          dbUserCpf !== localCpf ||
          dbUserCnpj !== localCnpj ||
          dbUserCrm !== localCrm ||
          dbUserBankAccount !== localBankAccount ||

          // NOTA: Identifica mudanças apenas na tela "plantões do usuário"
          (
            !!this.groupID === true && (
              dbCurrentUserGroupHourlyRate !== localCurrentUserGroupHourlyRate ||
              dbCurrentUserGroupNickname !== localCurrentUserGroupNickname ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserHourlyRate !== localSelectedScaleCurrentUserHourlyRate) ||
              // (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserGeneralHourlyRate !== localSelectedScaleCurrentUserGeneralHourlyRate) ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserWeekdaysHourlyRate !== localSelectedScaleCurrentUserWeekdaysHourlyRate) ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserWeekendHourlyRate !== localSelectedScaleCurrentUserWeekendHourlyRate) ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserDayShiftHourlyRate !== localSelectedScaleCurrentUserDayShiftHourlyRate) ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserNightShiftHourlyRate !== localSelectedScaleCurrentUserNightShiftHourlyRate) ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate !== localSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate) ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate !== localSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate) ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserWeekendDayShiftHourlyRate !== localSelectedScaleCurrentUserWeekendDayShiftHourlyRate) ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserWeekendNightShiftHourlyRate !== localSelectedScaleCurrentUserWeekendNightShiftHourlyRate) ||
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserMonthlyRate !== localSelectedScaleCurrentUserMonthlyRate)
              /*
              // [staging-portaltelemedicina / master-portaltelemedicina]
              (this.selectedScaleID !== '' && dbSelectedScaleCurrentUserConsultationTime !== localSelectedScaleCurrentUserConsultationTime)
              // [staging-portaltelemedicina / master-portaltelemedicina]
              */
            )
          ) ||
          this.capabilitiesChanged
        )
      },

      groupScales ()
      {
        return !!this.listeners === true && !!this.listeners.groupScales === true && Array.isArray(this.listeners.groupScales) && this.listeners.groupScales.length > 0 ? this.listeners.groupScales : []
      },

      scalesOptions ()
      {
        return this.groupScales.length > 0 ? this.groupScales.map(scale => ({ key: 'scale_' + scale.scaleID, value: scale.scaleID, text: scale.scaleName })) : []
      },
    },

    //
    //
    //

    watch: {
      dialog: {
        // the callback will be called immediately after the start of the observation
        immediate: true,
        handler (newDialog, oldDialog) {
          if (!!newDialog === false) this.clear()
        },
      },
    },

    methods: {
      //
      // METHODS TO HANDLE WINDOW OPENING AND CLOSING
      //

      async open (userID, groupID = false)
      {
        this.userID = userID
        this.groupID = groupID

        this.loadingWindow = true
        this.dialog = true

        // Grupo
        const perfil = await getUserByUserID(userID)
        const p = !!perfil === true ? processUserProfile(perfil) : false
        const userGroup = !!p === true && !!p.grupos === true && !!p.grupos[groupID] === true ? p.grupos[groupID] : null

        if (!!p === true) this.local.nome = p.userName || ''
        if (!!p === true) this.local.telefone = p.telefone || ''
        if (!!p === true) this.local.cpf = p.cpf || ''
        if (!!p === true) this.local.cnpj = p.cnpj || ''
        if (!!p === true) this.local.crm = p.crm || ''
        if (!!p === true) this.local.conta = p.conta || ''
        if (!!p === true) this.local.contaFormatada = !!p.conta === true ? (p.conta + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, ('$1' + '<br />' + '$2')) : '&nbsp;'
        if (!!userGroup === true) this.local.groupHourlyRate = userGroup.hourlyrate || '0' // Nota: hourlyrate pode não existir, então o padrão é R$ 0,00
        if (!!userGroup === true) this.local.groupNickname = userGroup.nickname || ''

        // NOTA: Ainda não vai definir o valor, pois a janela acabou de abrir e a escala ainda não está selecionada
        // selectedScaleHourlyRate

        //

        if (!!p === true) this.perfil.img = p.img || userProfileBroken // Senhor Jesus
        if (!!p === true) this.perfil.nome = p.userName || ''
        if (!!p === true) this.perfil.telefone = p.telefone || ''
        if (!!p === true) this.perfil.cpf = p.cpf || ''
        if (!!p === true) this.perfil.cnpj = p.cnpj || ''
        if (!!p === true) this.perfil.crm = p.crm || ''
        if (!!p === true) this.perfil.conta = p.conta || ''
        if (!!p === true) this.perfil.contaFormatada = !!p.conta === true ? (p.conta + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, ('$1' + '<br />' + '$2')) : '&nbsp;'
        if (!!userGroup === true) this.perfil.groupHourlyRate = userGroup.hourlyrate || '0' // Nota: hourlyrate pode não existir, então o padrão é R$ 0,00
        if (!!userGroup === true) this.perfil.groupNickname = userGroup.nickname || ''

        // NOTA: Objeto perfil (que contém dados sincronizados em tempo real à partir do banco por meio do groupScales) vai sempre mostrar o valor da escala selecionada pelo usuário
        // selectedScaleHourlyRate

        // console.log('::: USER GROUP:', userGroup)
        // console.log('::: userCapabilitiesPerGroup:', this.userCapabilitiesPerGroup)

        if (!!userGroup === true)
        {
          // Pode alterar capacidades de GESTOR e MASTER
          this.showUserCapabilities = !!this.$store.state.app.userSession.groups[groupID].master === true && !!userGroup.admin === true

          // Pode alterar capacidades de QUALQUER NÍVEL (MEMBRO, GESTOR e/ou MASTER)
          // this.showUserCapabilities = !!this.$store.state.app.userSession.groups[groupID].master === true

          const processedCapabilities = processUserGroupCapabilities(!!p === true && !!p.grupos === true ? p.grupos : null, groupID)

          const capabilityGroups = Object.keys(this.userCapabilitiesPerGroup)
          capabilityGroups.forEach(group => {
            this.userCapabilitiesPerGroup[group].forEach(capability => {
              this.userCapabilitiesInGroup[capability.value] = processedCapabilities[capability.value]
            })
          })
        }

        /* AVISA A UI QUE TERMINOU DE CARREGAR OS DETALHES DO PLANTÃO */
        this.loadingWindow = false
      },

      closeUser () {
        if (this.loadingWindow || this.saving) return

        this.dialog = false
      },

      clear ()
      {
        // this.dialog = false
        this.loadingWindow = true
        this.saving = false

        this.selectedScaleID = ''
        this.groupID = ''
        this.userID = ''

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        this.scaleConsultationDuration = '0'
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        this.local = {
          nome: '',
          telefone: '',
          cpf: '',
          cnpj: '',
          crm: '',
          conta: '',
          contaFormatada: '',
          groupHourlyRate: '0',
          groupNickname: '',
          selectedScaleHourlyRate: '0',
          // selectedGeneralHourlyRate: '0',
          selectedWeekdaysHourlyRate: '0',
          selectedWeekendHourlyRate: '0',
          selectedDayShiftHourlyRate: '0',
          selectedNightShiftHourlyRate: '0',
          selectedWeekdaysDayShiftHourlyRate: '0',
          selectedWeekdaysNightShiftHourlyRate: '0',
          selectedWeekendDayShiftHourlyRate: '0',
          selectedWeekendNightShiftHourlyRate: '0',
          // Valor mensal
          selectedScaleMonthlyRate: '0',
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          // Duração da consulta agendada
          scaleConsultationDuration: '0',
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        }
        this.perfil = {
          img: userProfileBroken,
          nome: 'Carregando...',
          telefone: 'Carregando...',
          cpf: 'Carregando...',
          cnpj: 'Carregando...',
          crm: 'Carregando...',
          conta: 'Carregando...',
          groupHourlyRate: 'Carregando...',
          groupNickname: 'Carregando...',
          selectedScaleHourlyRate: 'Carregando...',
          // selectedGeneralHourlyRate: 'Carregando...',
          selectedWeekdaysHourlyRate: 'Carregando...',
          selectedWeekendHourlyRate: 'Carregando...',
          selectedDayShiftHourlyRate: 'Carregando...',
          selectedNightShiftHourlyRate: 'Carregando...',
          selectedWeekdaysDayShiftHourlyRate: 'Carregando...',
          selectedWeekdaysNightShiftHourlyRate: 'Carregando...',
          selectedWeekendDayShiftHourlyRate: 'Carregando...',
          selectedWeekendNightShiftHourlyRate: 'Carregando...',
          selectedScaleMonthlyRate: 'Carregando...',
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          scaleConsultationDuration: 'Carregando...',
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        }

        // Editar capacidades do usuário (Funcionalidade de usuário master)
        this.showUserCapabilities = false
        this.userCapabilitiesPerGroup = userCapabilitiesPerGroup()
        this.userCapabilitiesInGroup = {}
        this.capabilitiesChanged = false
      },

      //
      // ON CHANGE LISTENERS/EVENTS
      //

      onSelectScale (scaleID, scaleName)
      {
        this.selectedScaleID = scaleID

        const s = this.groupScales.find(scale => scale.scaleID === scaleID)

        if (!!s === true && !!s.scaleUsers === true && !!s.scaleUsers[this.userID] === true)
        {
          this.local.selectedScaleHourlyRate = s.scaleUsers[this.userID].hourlyrate || '0'
          // this.local.selectedGeneralHourlyRate = s.scaleUsers[this.userID].generalHourlyRate || '0'
          this.local.selectedWeekdaysHourlyRate = s.scaleUsers[this.userID].weekdaysHourlyRate || '0'
          this.local.selectedWeekendHourlyRate = s.scaleUsers[this.userID].weekendHourlyRate || '0'
          this.local.selectedDayShiftHourlyRate = s.scaleUsers[this.userID].dayShiftHourlyRate || '0'
          this.local.selectedNightShiftHourlyRate = s.scaleUsers[this.userID].nightShiftHourlyRate || '0'
          this.local.selectedWeekdaysDayShiftHourlyRate = s.scaleUsers[this.userID].weekdaysDayShiftHourlyRate || '0'
          this.local.selectedWeekdaysNightShiftHourlyRate = s.scaleUsers[this.userID].weekdaysNightShiftHourlyRate || '0'
          this.local.selectedWeekendDayShiftHourlyRate = s.scaleUsers[this.userID].weekendDayShiftHourlyRate || '0'
          this.local.selectedWeekendNightShiftHourlyRate = s.scaleUsers[this.userID].weekendNightShiftHourlyRate || '0'
          this.local.selectedScaleMonthlyRate = s.scaleUsers[this.userID].monthlyrate || '0'
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          this.local.scaleConsultationDuration = s.scaleUsers[this.userID].consultationtime || '0'
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */

          this.perfil.selectedScaleHourlyRate = s.scaleUsers[this.userID].hourlyrate || '0'
          // this.perfil.selectedGeneralHourlyRate = s.scaleUsers[this.userID].generalHourlyRate || '0'
          this.perfil.selectedWeekdaysHourlyRate = s.scaleUsers[this.userID].weekdaysHourlyRate || '0'
          this.perfil.selectedWeekendHourlyRate = s.scaleUsers[this.userID].weekendHourlyRate || '0'
          this.perfil.selectedDayShiftHourlyRate = s.scaleUsers[this.userID].dayShiftHourlyRate || '0'
          this.perfil.selectedNightShiftHourlyRate = s.scaleUsers[this.userID].nightShiftHourlyRate || '0'
          this.perfil.selectedWeekdaysDayShiftHourlyRate = s.scaleUsers[this.userID].weekdaysDayShiftHourlyRate || '0'
          this.perfil.selectedWeekdaysNightShiftHourlyRate = s.scaleUsers[this.userID].weekdaysNightShiftHourlyRate || '0'
          this.perfil.selectedWeekendDayShiftHourlyRate = s.scaleUsers[this.userID].weekendDayShiftHourlyRate || '0'
          this.perfil.selectedWeekendNightShiftHourlyRate = s.scaleUsers[this.userID].weekendNightShiftHourlyRate || '0'
          this.perfil.selectedScaleMonthlyRate = s.scaleUsers[this.userID].monthlyrate || '0'
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          this.perfil.scaleConsultationDuration = s.scaleUsers[this.userID].consultationtime || '0'
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        }
        else
        {
          this.local.selectedScaleHourlyRate = '0'
          // this.local.selectedGeneralHourlyRate = '0'
          this.local.selectedWeekdaysHourlyRate = '0'
          this.local.selectedWeekendHourlyRate = '0'
          this.local.selectedDayShiftHourlyRate = '0'
          this.local.selectedNightShiftHourlyRate = '0'
          this.local.selectedWeekdaysDayShiftHourlyRate = '0'
          this.local.selectedWeekdaysNightShiftHourlyRate = '0'
          this.local.selectedWeekendDayShiftHourlyRate = '0'
          this.local.selectedWeekendNightShiftHourlyRate = '0'
          this.local.selectedScaleMonthlyRate = '0'
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          this.local.scaleConsultationDuration = '0'
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */

          this.perfil.selectedScaleHourlyRate = '0'
          // this.perfil.selectedGeneralHourlyRate = '0'
          this.perfil.selectedWeekdaysHourlyRate = '0'
          this.perfil.selectedWeekendHourlyRate = '0'
          this.perfil.selectedDayShiftHourlyRate = '0'
          this.perfil.selectedNightShiftHourlyRate = '0'
          this.perfil.selectedWeekdaysDayShiftHourlyRate = '0'
          this.perfil.selectedWeekdaysNightShiftHourlyRate = '0'
          this.perfil.selectedWeekendDayShiftHourlyRate = '0'
          this.perfil.selectedWeekendNightShiftHourlyRate = '0'
          this.perfil.selectedScaleMonthlyRate = '0'
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          this.perfil.scaleConsultationDuration = '0'
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        }

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        this.scaleConsultationDuration = !!s === true ? String(s.scaleConsultationDuration || '0') : '0'
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */
      },

      onCpfChange (val)
      {
        let v = String(val.target.value)

        // Remove tudo o que não é dígito
        v = v.replace(/[^0-9]/g, '')

        if (v.length === 0) {
          val.target.value = ''
          this.local.cpf = ''

          return false
        }

        // Aplica a máscara de CPF: 000.000.000-00
        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')

        // Garante que não ultrapasse o tamanho do CPF formatado
        v = v.slice(0, 14)

        val.target.value = v
        this.local.cpf = v
      },

      onCnpjChange(val) {
        let v = String(val.target.value)

        // Remove tudo o que não é dígito
        v = v.replace(/\D/g, '')

        if (v.length === 0) {
          val.target.value = ''
          this.local.cnpj = ''
          return false
        }

        // Aplica a máscara de CNPJ: 00.000.000/0000-00
        v = v.replace(/^(\d{2})(\d)/, '$1.$2')
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        v = v.replace(/\.(\d{3})(\d)/, '.$1/$2')
        v = v.replace(/(\d{4})(\d)/, '$1-$2')

        // Garante que não ultrapasse o tamanho do CNPJ formatado
        v = v.slice(0, 18)

        val.target.value = v
        this.local.cnpj = v

        return true
      },

      onPhoneChange (val)
      {
        let v = String(val.target.value)

        var len = 0

        // Remove tudo o que não é dígito
        v = v.replace(/[^0-9]/g, '')

        len = v.length

        if (len === 0) {
          val.target.value = ''
          this.local.telefone = ''

          return false
        }

        if (len > 11) {
          const maskedPhone = applyPhoneMask(this.local.telefone || '')

          val.target.value = maskedPhone
          this.local.telefone = maskedPhone

          return false
        }

        // Coloca parênteses em volta dos dois primeiros dígitos
        v = v.replace(/^(\d\d)(\d)/g, '($1) $2')

        // Coloca hífen entre o quarto e o quinto dígitos
        v = len > 10 ? v.replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15) : v.replace(/(\d{4})(\d)/, '$1-$2').slice(0, 14)

        val.target.value = v
        this.local.telefone = v
      },

      onBlurUserGroupHourlyRateValue (value)
      {
        this.local.groupHourlyRate = value
      },

      onInputUserScaleHourlyRateValue (value)
      {
        this.local.selectedScaleHourlyRate = value
      },

      // onInputUserScaleGeneralHourlyRate (value)
      // {
      //   this.local.selectedGeneralHourlyRate = value
      // },

      onInputUserScaleWeekdaysHourlyRate (value)
      {
        this.local.selectedWeekdaysHourlyRate = value
      },

      onInputUserScaleWeekendHourlyRate (value)
      {
        this.local.selectedWeekendHourlyRate = value
      },

      onInputUserScaleDayShiftHourlyRate (value)
      {
        this.local.selectedDayShiftHourlyRate = value
      },

      onInputUserScaleNightShiftHourlyRate (value)
      {
        this.local.selectedNightShiftHourlyRate = value
      },

      onInputUserScaleWeekdaysDayShiftHourlyRate (value)
      {
        this.local.selectedWeekdaysDayShiftHourlyRate = value
      },

      onInputUserScaleWeekdaysNightShiftHourlyRate (value)
      {
        this.local.selectedWeekdaysNightShiftHourlyRate = value
      },

      onInputUserScaleWeekendDayShiftHourlyRate (value)
      {
        this.local.selectedWeekendDayShiftHourlyRate = value
      },

      onInputUserScaleWeekendNightShiftHourlyRate (value)
      {
        this.local.selectedWeekendNightShiftHourlyRate = value
      },

      onInputUserScaleMonthlyRateValue (value)
      {
        this.local.selectedScaleMonthlyRate = value
      },

      onBlurUserScaleHourlyRateValue (value)
      {
        // this.local.selectedScaleHourlyRate = value
      },

      onBlurUserScaleMonthlyRateValue (value)
      {
        // this.local.selectedScaleHourlyRate = value
      },

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      onSelectConsultationTimeDisabled (consultationTime)
      {
        // this.scaleConsultationDuration = consultationTime
      },

      onSelectConsultationTime (consultationTime)
      {
        this.local.scaleConsultationDuration = consultationTime
      },
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      //
      // SAVE THE USER PROFILE TO THE DATABASE
      //

      async saveUser ()
      {
        if (this.saving) return false

        if (!this.hasChanges)
        {
          // [TESTAR/TRATAR] Correção ao colar um número maior que 11 digitos
          const fixCpf = this.local.cpf.replace(/[^0-9]/g, '')
          if (fixCpf.length > 11) this.local.cpf = applyCpfMask(fixCpf.slice(0, 11))
          // [TESTAR/TRATAR] Correção ao colar um número maior que 11 digitos

          // [TESTAR/TRATAR] Correção ao colar um número maior que 14 digitos
          const fixCnpj = this.local.cnpj.replace(/[^0-9]/g, '')
          if (fixCnpj.length > 14) this.local.cnpj = applyCnpjMask(fixCnpj.slice(0, 14))
          // [TESTAR/TRATAR] Correção ao colar um número maior que 14 digitos

          // [24/01/25] console.log('::: NENHUM CAMPO FOI ALTERADO')
          return false
        }

        // console.log('saveUser:', this.userID, this.perfil, this.local)

        //
        // TRATA CAMPOS ATUAIS
        // > DADOS NO BANCO
        //

        const dbUserName = String(this.perfil.nome || '').trim()
        const dbUserPhone = String(this.perfil.telefone || '').trim()
        let dbUserCpf = String(this.perfil.cpf || '').replace(/[^0-9]/g, '')
        dbUserCpf = dbUserCpf.length > 11 ? dbUserCpf.slice(0, 11) : dbUserCpf
        let dbUserCnpj = String(this.perfil.cnpj || '').replace(/[^0-9]/g, '')
        dbUserCnpj = dbUserCnpj.length > 14 ? dbUserCnpj.slice(0, 14) : dbUserCnpj
        const dbUserCrm = String(this.perfil.crm || '').trim()
        const dbUserBankAccount = String(this.perfil.conta || '').trim()
        const dbCurrentUserGroupHourlyRate = this.perfil.groupHourlyRate
        const dbCurrentUserGroupNickname = String(this.perfil.groupNickname || '').trim()
        const dbSelectedScaleCurrentUserHourlyRate = this.perfil.selectedScaleHourlyRate // || '0'
        // const dbSelectedScaleCurrentUserGeneralHourlyRate = this.perfil.selectedGeneralHourlyRate
        const dbSelectedScaleCurrentUserWeekdaysHourlyRate = this.perfil.selectedWeekdaysHourlyRate
        const dbSelectedScaleCurrentUserWeekendHourlyRate = this.perfil.selectedWeekendHourlyRate
        const dbSelectedScaleCurrentUserDayShiftHourlyRate = this.perfil.selectedDayShiftHourlyRate
        const dbSelectedScaleCurrentUserNightShiftHourlyRate = this.perfil.selectedNightShiftHourlyRate
        const dbSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate = this.perfil.selectedWeekdaysDayShiftHourlyRate
        const dbSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate = this.perfil.selectedWeekdaysNightShiftHourlyRate
        const dbSelectedScaleCurrentUserWeekendDayShiftHourlyRate = this.perfil.selectedWeekendDayShiftHourlyRate
        const dbSelectedScaleCurrentUserWeekendNightShiftHourlyRate = this.perfil.selectedWeekendNightShiftHourlyRate
        const dbSelectedScaleCurrentUserMonthlyRate = this.perfil.selectedScaleMonthlyRate // || '0'
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        const dbSelectedScaleCurrentUserConsultationTime = this.perfil.scaleConsultationDuration // || '0'
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        //
        // TRATA OS CAMPOS QUE O GESTOR PODE ALTERAR
        // > DADOS DO BANCO, MAS QUE O GESTOR PODE ALTERAR POR MEIO DA JANELA ATUAL
        //

        const localName = String(this.local.nome || '').trim()
        const localPhone = String(this.local.telefone || '').trim()
        let localCpf = String(this.local.cpf || '').replace(/[^0-9]/g, '')
        localCpf = localCpf.length > 11 ? localCpf.slice(0, 11) : localCpf
        let localCnpj = String(this.local.cnpj || '').replace(/[^0-9]/g, '')
        localCnpj = localCnpj.length > 14 ? localCnpj.slice(0, 14) : localCnpj
        const localCrm = String(this.local.crm || '').trim()
        const localBankAccount = String(this.local.conta || '').trim()
        const localCurrentUserGroupHourlyRate = this.local.groupHourlyRate
        const localCurrentUserGroupNickname = String(this.local.groupNickname || '').trim()
        const localSelectedScaleCurrentUserHourlyRate = this.local.selectedScaleHourlyRate
        // const localSelectedScaleCurrentUserGeneralHourlyRate = this.local.selectedGeneralHourlyRate
        const localSelectedScaleCurrentUserWeekdaysHourlyRate = this.local.selectedWeekdaysHourlyRate
        const localSelectedScaleCurrentUserWeekendHourlyRate = this.local.selectedWeekendHourlyRate
        const localSelectedScaleCurrentUserDayShiftHourlyRate = this.local.selectedDayShiftHourlyRate
        const localSelectedScaleCurrentUserNightShiftHourlyRate = this.local.selectedNightShiftHourlyRate
        const localSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate = this.local.selectedWeekdaysDayShiftHourlyRate
        const localSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate = this.local.selectedWeekdaysNightShiftHourlyRate
        const localSelectedScaleCurrentUserWeekendDayShiftHourlyRate = this.local.selectedWeekendDayShiftHourlyRate
        const localSelectedScaleCurrentUserWeekendNightShiftHourlyRate = this.local.selectedWeekendNightShiftHourlyRate
        const localSelectedScaleCurrentUserMonthlyRate = this.local.selectedScaleMonthlyRate
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        const localSelectedScaleCurrentUserConsultationTime = this.local.scaleConsultationDuration
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        //
        // MOSTRA INFORMAÇÕES QUE MUDARAM
        //

        // [24/01/25] if (localName !== dbUserName) console.log(`CHANGED > Name: "${dbUserName}" > "${localName}"`)
        // [24/01/25] if (localPhone !== dbUserPhone) console.log(`CHANGED > Phone: "${dbUserPhone}" > "${localPhone}"`)
        // [24/01/25] if (localCpf !== dbUserCpf) console.log(`CHANGED > Cpf: "${dbUserCpf}" > "${localCpf}"`)
        // [24/01/25] if (localCnpj !== dbUserCnpj) console.log(`CHANGED > Cnpj: "${dbUserCnpj}" > "${localCnpj}"`)
        // [24/01/25] if (localCrm !== dbUserCrm) console.log(`CHANGED > Crm: "${dbUserCrm}" > "${localCrm}"`)
        // [24/01/25] if (localBankAccount !== dbUserBankAccount) console.log(`CHANGED > Bank Account: "${dbUserBankAccount}" > "${localBankAccount}"`)

        // [24/01/25] if (!!this.groupID === true) {
        // [24/01/25] if (localCurrentUserGroupHourlyRate !== dbCurrentUserGroupHourlyRate) console.log(`CHANGED > User Group Hourly Rate: "${dbCurrentUserGroupHourlyRate}" > "${localCurrentUserGroupHourlyRate}"`)
        // [24/01/25] if (localCurrentUserGroupNickname !== dbCurrentUserGroupNickname) console.log(`CHANGED > User Group Nickname: "${dbCurrentUserGroupNickname}" > "${localCurrentUserGroupNickname}"`)
        // [24/01/25] if (this.selectedScaleID !== '' && localSelectedScaleCurrentUserHourlyRate !== dbSelectedScaleCurrentUserHourlyRate) console.log(`CHANGED > Selected Scale Current User Hourly Rate: "${dbSelectedScaleCurrentUserHourlyRate}" > "${localSelectedScaleCurrentUserHourlyRate}"`)
        // [staging-portaltelemedicina / master-portaltelemedicina]
        // // [24/01/25] if (this.selectedScaleID !== '' && localSelectedScaleCurrentUserConsultationTime !== dbSelectedScaleCurrentUserConsultationTime) console.log(`CHANGED > Selected Scale Current User Consultation Time: "${dbSelectedScaleCurrentUserConsultationTime}" > "${localSelectedScaleCurrentUserConsultationTime}"`)
        // [staging-portaltelemedicina / master-portaltelemedicina]
        // [24/01/25] }

        //
        // INFORMAÇÕES QUE VÃO ENTRAR NO BD
        //

        let updatesCount = 0
        const updates = {}

        if (localName !== dbUserName)
        {
          if (checkUsername(localName)) {
            updates[`users/${this.userID}/nome`] = localName.trim()
            updatesCount++
          } else {
            this.local.nome = dbUserName || ''
          }
        }

        if (localPhone !== dbUserPhone)
        {
          if (checkPhone(localPhone)) {
            const thePhone = localPhone.split(' ')

            updates[`users/${this.userID}/ddd`] = thePhone[0].slice(1, 3).trim()
            updates[`users/${this.userID}/tel`] = thePhone[1].split('-').join('').trim()
            updatesCount++
          } else {
            this.local.telefone = dbUserPhone || ''
          }
        }

        if (localCpf !== dbUserCpf)
        {
          if ((this.isValidCPF(localCpf)) || (String(localCpf).length === 0)) {
            updates[`users/${this.userID}/cpf`] = localCpf // SENHOR: Correto?
            updatesCount++
          } else {
            // this.local.cpf = dbUserCpf
            this.local.cpf = dbUserCpf.length > 0 ? applyCpfMask(dbUserCpf || '') : ''
          }
        }

        if (localCnpj !== dbUserCnpj)
        {
          if ((this.isValidCNPJ(localCnpj)) || (String(localCnpj).length === 0)) {
            updates[`users/${this.userID}/cnpj`] = localCnpj // SENHOR: Correto?
            updatesCount++
          } else {
            // this.local.cnpj = dbUserCnpj
            this.local.cnpj = dbUserCnpj.length > 0 ? applyCnpjMask(dbUserCnpj || '') : ''
          }
        }

        if (localCrm !== dbUserCrm) {
          updates[`users/${this.userID}/crm`] = localCrm
          updatesCount++
        }

        if (localBankAccount !== dbUserBankAccount) {
          updates[`users/${this.userID}/conta`] = localBankAccount
          updatesCount++
        }

        if (!!this.groupID === true)
        {
          // Apelido
          if ((localCurrentUserGroupNickname !== dbCurrentUserGroupNickname)) {
            updates[`users/${this.userID}/grupos/${this.groupID}/nickname`] = localCurrentUserGroupNickname.length === 0 ? null : localCurrentUserGroupNickname
            updatesCount++
          }

          // Group user's hourly rate
          if (localCurrentUserGroupHourlyRate !== dbCurrentUserGroupHourlyRate) {
            updates[`users/${this.userID}/grupos/${this.groupID}/hourlyrate`] = parseFloat(localCurrentUserGroupHourlyRate) === 0 ? null : localCurrentUserGroupHourlyRate
            updatesCount++
          }

          if (this.selectedScaleID !== '')
          {
            // Valor hora do usuário na escala
            if (localSelectedScaleCurrentUserHourlyRate !== dbSelectedScaleCurrentUserHourlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/hourlyrate`] = parseFloat(localSelectedScaleCurrentUserHourlyRate) === 0 ? null : localSelectedScaleCurrentUserHourlyRate
              updatesCount++
            }

            // if (localSelectedScaleCurrentUserGeneralHourlyRate !== dbSelectedScaleCurrentUserGeneralHourlyRate && this.selectedScaleID !== '') {
            //   updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/generalHourlyRate`] = parseFloat(localSelectedScaleCurrentUserGeneralHourlyRate) === 0 ? null : localSelectedScaleCurrentUserGeneralHourlyRate
            //   updatesCount++
            // }

            if (localSelectedScaleCurrentUserWeekdaysHourlyRate !== dbSelectedScaleCurrentUserWeekdaysHourlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/weekdaysHourlyRate`] = parseFloat(localSelectedScaleCurrentUserWeekdaysHourlyRate) === 0 ? null : localSelectedScaleCurrentUserWeekdaysHourlyRate
              updatesCount++
            }
            if (localSelectedScaleCurrentUserWeekendHourlyRate !== dbSelectedScaleCurrentUserWeekendHourlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/weekendHourlyRate`] = parseFloat(localSelectedScaleCurrentUserWeekendHourlyRate) === 0 ? null : localSelectedScaleCurrentUserWeekendHourlyRate
              updatesCount++
            }
            if (localSelectedScaleCurrentUserDayShiftHourlyRate !== dbSelectedScaleCurrentUserDayShiftHourlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/dayShiftHourlyRate`] = parseFloat(localSelectedScaleCurrentUserDayShiftHourlyRate) === 0 ? null : localSelectedScaleCurrentUserDayShiftHourlyRate
              updatesCount++
            }
            if (localSelectedScaleCurrentUserNightShiftHourlyRate !== dbSelectedScaleCurrentUserNightShiftHourlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/nightShiftHourlyRate`] = parseFloat(localSelectedScaleCurrentUserNightShiftHourlyRate) === 0 ? null : localSelectedScaleCurrentUserNightShiftHourlyRate
              updatesCount++
            }
            if (localSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate !== dbSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/weekdaysDayShiftHourlyRate`] = parseFloat(localSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate) === 0 ? null : localSelectedScaleCurrentUserWeekdaysDayShiftHourlyRate
              updatesCount++
            }
            if (localSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate !== dbSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/weekdaysNightShiftHourlyRate`] = parseFloat(localSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate) === 0 ? null : localSelectedScaleCurrentUserWeekdaysNightShiftHourlyRate
              updatesCount++
            }
            if (localSelectedScaleCurrentUserWeekendDayShiftHourlyRate !== dbSelectedScaleCurrentUserWeekendDayShiftHourlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/weekendDayShiftHourlyRate`] = parseFloat(localSelectedScaleCurrentUserWeekendDayShiftHourlyRate) === 0 ? null : localSelectedScaleCurrentUserWeekendDayShiftHourlyRate
              updatesCount++
            }
            if (localSelectedScaleCurrentUserWeekendNightShiftHourlyRate !== dbSelectedScaleCurrentUserWeekendNightShiftHourlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/weekendNightShiftHourlyRate`] = parseFloat(localSelectedScaleCurrentUserWeekendNightShiftHourlyRate) === 0 ? null : localSelectedScaleCurrentUserWeekendNightShiftHourlyRate
              updatesCount++
            }

            // Valor mensal do usuário na escala
            if (localSelectedScaleCurrentUserMonthlyRate !== dbSelectedScaleCurrentUserMonthlyRate && this.selectedScaleID !== '') {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/monthlyrate`] = parseFloat(localSelectedScaleCurrentUserMonthlyRate) === 0 ? null : localSelectedScaleCurrentUserMonthlyRate
              updatesCount++
            }

            /*
            // [staging-portaltelemedicina / master-portaltelemedicina]
            // "Tempo de consulta" do usuário na escala
            if (localSelectedScaleCurrentUserConsultationTime !== dbSelectedScaleCurrentUserConsultationTime) {
              updates[`escalas/${this.groupID}/${this.selectedScaleID}/users/${this.userID}/consultationtime`] = parseFloat(localSelectedScaleCurrentUserConsultationTime) === 0 ? null : localSelectedScaleCurrentUserConsultationTime
              updatesCount++
            }
            // [staging-portaltelemedicina / master-portaltelemedicina]
            */
          }
        }

        if (this.capabilitiesChanged)
        {
          const disabledCapabilities = processSelectedCapabilities(this.userCapabilitiesInGroup)

          // [24/01/25] console.log('::: disabledCapabilities:', disabledCapabilities)

          updates[`grupos/${this.groupID}/users/${this.userID}/disabledCapabilities`] = disabledCapabilities
          updates[`users/${this.userID}/grupos/${this.groupID}/disabledCapabilities`] = disabledCapabilities
          updatesCount++
        }

        // [24/01/25] console.log('::: SALVAR PERFIL:', updatesCount, updates)

        //
        // COLOCA NO BANCO DE DADOS
        //

        if (updatesCount > 0)
        {
          this.saving = true // AVISA A UI QUE ESTÁ ATUALIZANDO O USUÁRIO

          const response = await fbFullUpdate(updates)

          // Não conseguimos salvar seus dados. Por favor, contate nosso suporte.
          if (response.code === 0) {
            this.saving = false
            return false
          }

          //
          // NOTA FIRMINO:
          // Comentado em 15/10/24 para forçar a reabertura da janela e evitar possíveis bugs
          // É necessário que o usuário continue editando e salvando sem fechar? Basta descomentar abaixo. (Não testado)
          //

          /*

          // Grupo
          const perfil = await getUserByUserID(this.userID)
          const p = !!perfil === true ? processUserProfile(perfil) : false
          const userGroup = !!p === true && !!p.grupos === true && !!p.grupos[this.groupID] === true ? p.grupos[this.groupID] : null

          // Escala
          // const selectedScaleHourlyRate =

          //

          if (!!p === true) this.local.nome = p.userName || ''
          if (!!p === true) this.local.telefone = p.telefone || ''
          if (!!p === true) this.local.cpf = p.cpf || ''
          if (!!p === true) this.local.cnpj = p.cnpj || ''
          if (!!p === true) this.local.crm = p.crm || ''
          if (!!p === true) this.local.conta = p.conta || ''
          if (!!p === true) this.local.contaFormatada = !!p.conta === true ? (p.conta + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, ('$1' + '<br />' + '$2')) : '&nbsp;'
          if (!!userGroup === true) this.local.groupHourlyRate = userGroup.hourlyrate || '0' // Nota: hourlyrate pode não existir, então o padrão é R$ 0,00
          if (!!userGroup === true) this.local.groupNickname = userGroup.nickname || ''

          // NOTA: Vai definir o valor, pois a escala está selecionada (JESUS: É necessário?)
          // if (!!this.selectedScaleCurrentUserHourlyRate === true) this.local.selectedScaleHourlyRate = this.selectedScaleCurrentUserHourlyRate

          //

          if (!!p === true) this.perfil.img = p.img || userProfileBroken // Senhor Jesus
          if (!!p === true) this.perfil.nome = p.userName || ''
          if (!!p === true) this.perfil.telefone = p.telefone || ''
          if (!!p === true) this.perfil.cpf = p.cpf || ''
          if (!!p === true) this.perfil.cnpj = p.cnpj || ''
          if (!!p === true) this.perfil.crm = p.crm || ''
          if (!!p === true) this.perfil.conta = p.conta || ''
          if (!!p === true) this.perfil.contaFormatada = !!p.conta === true ? (p.conta + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, ('$1' + '<br />' + '$2')) : '&nbsp;'
          if (!!userGroup === true) this.perfil.groupHourlyRate = userGroup.hourlyrate || '0' // Nota: hourlyrate pode não existir, então o padrão é R$ 0,00
          if (!!userGroup === true) this.perfil.groupNickname = userGroup.nickname || ''

          // NOTA: Objeto perfil (que contém dados sincronizados em tempo real à partir do banco por meio do groupScales) vai sempre mostrar o valor da escala selecionada pelo usuário (selectedScaleCurrentUserHourlyRate)
          if (!!this.selectedScaleCurrentUserHourlyRate === true) this.perfil.selectedScaleHourlyRate = this.selectedScaleCurrentUserHourlyRate */

          //

          this.saving = false // AVISA A UI QUE TERMINOU DE CARREGAR OS DETALHES

          this.$emit('onUpdate')

          this.closeUser()
        }
      },

      onSelectedUserCapabilityInGroup (capabilityValue) {
        // const newCapabilities = { ...this.userCapabilitiesInGroup }
        // newCapabilities[capabilityValue] = !newCapabilities[capabilityValue]
        // this.userCapabilitiesInGroup = newCapabilities

        this.userCapabilitiesInGroup[capabilityValue] = !this.userCapabilitiesInGroup[capabilityValue]
        this.userCapabilitiesInGroup = { ...this.userCapabilitiesInGroup }

        this.capabilitiesChanged = true
      },
    },
  }

</script>

<style lang="scss" scoped>

  .userEditTitle {
    color: slategrey;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
  }

  .dutyDetails {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);

    font-size: 0;
  }

  .userField {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: 30px;
    padding: 0;
    outline: 0;
    border: 0;
    box-shadow: none;

    color: steelblue;
    // color: #656565;
    font-size: 16px;
    line-height: 30px;

    &--userName {
      padding-left: 40px;
      padding-right: 10px;
    }

    &--readonly {
      color: #656565;
    }

    &::placeholder {
      color: rgba(70, 130, 180, 0.7);
      // color: #656565;
    }
  }

  .userFieldBankAccount {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: 70px;
    padding-right: 10px;
    outline: 0;
    border: 0;

    color: steelblue;
    // color: #656565;
    font-size: 16px;
    min-height: 70px;
    line-height: 30px;
    max-height: 150px;

    &::placeholder {
      color: rgba(70, 130, 180, 0.7);
      // color: #656565;
    }
  }

  .dutyDetail {
    padding: 5px 5px 5px 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 16px;
    line-height: 30px;
  }

  .dutyDetailButton {
    margin-top: 20px;
    text-align: right;
  }

  .dutyDetailName,
  .dutyDetailValue {
    display: inline-block;
    vertical-align: middle;

    &.dutyDetailName--textarea,
    &.dutyDetailValue--textarea {
      vertical-align: top;
    }
  }

  .dutyDetailName {
    width: 29%;
    padding-right: 10px;

    font-size: 15px;
    font-weight: 600;
    line-height: 30px;

    &--heightFix {
      line-height: 1;
    }
    &--disabled {
      opacity: 0.5;
    }

    &.unsetWidth {
      width: 100%;
    }
  }

  .dutyDetailValue {
    position: relative;
    width: 71%;
    padding-left: 15px;
    border-left: 1px solid rgba(0, 0, 0, 0.1);

    &--conta {
      min-height: 70px;
    }

    &--disabled {
      opacity: 0.5;
    }
  }

  .dutyDetailText {
    display: inline-block;

    color: #656565;
    font-size: 16px;
    line-height: 30px;
  }

  .dutyDetailTextarea {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    max-height: 70px; // rolagem
    padding-right: 10px;
    overflow: auto; // rolagem

    color: #656565;
    font-size: 16px;
    line-height: 30px;
  }

  .editUserUserImage,
  .editUserUserName {
    display: inline-block;
    vertical-align: top;
  }

  .editUserUserImage {
    position: absolute;
    left: 15px;
    bottom: 0;
    top: 0;

    width: 30px;
    margin: auto 0;
    border-radius: 100%;
  }

  .editUserUserName {
    width: 100%;
    padding-left: 40px;
    padding-right: 10px;

    color: #656565;
    font-size: 16px;

    // Reticências
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .scaleMonthlyRateTextDisabled {
    display: inline-block;
    font-size: 16px;
    font-weight: 300;
    color: slategray;
  }

  @media (max-width: 600px)
  {
    .dutyDetailName,
    .dutyDetailValue {
      vertical-align: top;
    }

    .editUserUserImage {
      left: 0;
    }

    .dutyDetailName {
      width: 100%;
    }

    .dutyDetailValue {
      width: 100%;
      padding-left: 0;
      border-left: 0;
    }
  }

</style>
